export default __webpack_public_path__ + "static/media/7_1.2f00b4dc.jpg";